var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsIn, IsNotEmpty, IsObject, IsOptional, IsString } from 'class-validator';
import { Action } from './action.enum.js';
export class CheckAbilityDto {
    subject; // runtime validation of allowed values occurs in ability factory
    action;
    dto;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    Expose(),
    __metadata("design:type", String)
], CheckAbilityDto.prototype, "subject", void 0);
__decorate([
    IsIn(Object.values(Action)),
    IsNotEmpty(),
    Expose(),
    __metadata("design:type", String)
], CheckAbilityDto.prototype, "action", void 0);
__decorate([
    IsObject(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], CheckAbilityDto.prototype, "dto", void 0);
export class CheckAbilityResponseDto {
    allowed;
}
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CheckAbilityResponseDto.prototype, "allowed", void 0);
//# sourceMappingURL=check-ability.dto.js.map